import { render } from "./LogTel.vue?vue&type=template&id=1efde54b"
import script from "./LogTel.vue?vue&type=script&lang=js"
export * from "./LogTel.vue?vue&type=script&lang=js"

import "./LogTel.vue?vue&type=style&index=0&id=1efde54b&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__